import { useForm } from 'react-hook-form';
import { Button, Loading } from '../../../../components';
import InputField from '../../../../components/generic/InputField/InputField';

import UserAutocompletion from '../../../../components/common/UserAutocompletion';
import QueryErrorBoundary from '../../../../components/error-handling';

interface FormProps {
  onFinish: any;
  data?: any;
  loading?: boolean;
  error?: any;
  type?: string;
}

const SectionOwnerForm = ({
  data,
  onFinish,
  loading,
  error,
  type,
}: FormProps) => {
  const {
    register,
    handleSubmit,
    reset,
    control,
    watch,
    formState: { isDirty, errors },
  } = useForm();

  const email = watch('email');

  const isEdited = isDirty || email !== data?.email;

  return (
    <QueryErrorBoundary error={error}>
      <form
        className="flex flex-col w-full"
        onSubmit={handleSubmit((data) => onFinish(data))}
      >
        {!loading ? (
          <>
            <UserAutocompletion
              register={register}
              control={control}
              errors={errors}
              watch={watch}
              reset={reset}
              currentData={data}
              isSectionOwner
              editable
            />
            {type !== 'location' && (
              <InputField
                type="select"
                label="Section Required"
                name="sectionRequired"
                rules={{ required: true }}
                register={register}
                control={control}
                defaultValue={data?.sectionRequired ? 'true' : 'false'}
                errors={errors.sectionRequired}
                errorMessage="This field is required."
                selectOptions={[
                  { label: 'Yes', value: 'true' },
                  { label: 'No', value: 'false' },
                ]}
                spaceBetween
              />
            )}
            <div className="flex justify-end mt-4">
              <Button
                htmlType="submit"
                type="primary"
                className={`text-sm min-w-[180px] h-5 py-3 ${
                  isEdited
                    ? ''
                    : 'disabled:opacity-50 disabled:cursor-not-allowed  flex items-center justify-center'
                }`}
                disabled={!isEdited}
              >
                Save
              </Button>
            </div>
          </>
        ) : (
          <Loading />
        )}
      </form>
    </QueryErrorBoundary>
  );
};

export default SectionOwnerForm;
